<template>
  <sModal
    v-model="modalNewCabinet"
    :title="`${$t('Common.OldCabinet.ModalTitle')}!`">
    <div>
      <div style="font-size: 14px; line-height: 18px;">
        <div>{{ $t('Common.OldCabinet.row1') }}</div>
        <div class="mt-3">
          {{ $t('Common.OldCabinet.row2') }}
        </div>
        <div class="mt-3">
          <span>{{ $t('Common.OldCabinet.row3') }}</span>
          <router-link
            class="ml-1"
            style="text-decoration: underline !important;"
            :to="{name: 'releases'}"
            @click.native="modalNewCabinet = false">
            {{ $t('Common.OldCabinet.toLink') }}
          </router-link>.
        </div>
        <div class="mt-3">
          <span>{{ $t('Common.OldCabinet.row4') }}</span>
          <a
            class="ml-1"
            :href="$t('Common.OldCabinet.instructionLink')"
            style="text-decoration: underline !important;">{{ $t('Common.OldCabinet.toLink') }}</a>.
        </div>
        <div class="mt-4">
          {{ $t('Common.OldCabinet.row5') }}
        </div>
      </div>
      <div
        v-if="manager"
        class="flex flex-between mt-7"
        style="font-weight: 500; font-size: 14px;">
        <div
          v-if="manager.fullName"
          class="flex"
          style="width: 60%;">
          <UserIcon
            v-if="manager.fullName"
            class="mr-2 my-auto"
            data-qa="manager-avatar"
            :name="manager.fullName || ''"
            size="32"
            :src=" manager.avatar || ''"/>
          <div
            class="my-auto"
            data-qa="manager-name">
            {{ manager.fullName }}
          </div>
        </div>
        <div
          v-if="manager.email || manager.phones"
          class="text-left"
          style="width: 40%;">
          <div
            v-if="manager.email"
            data-qa="manager-email"
            style="text-decoration-line: underline;">
            {{ manager.email }}
          </div>
          <div
            v-if="manager.phones && manager.phones.length"
            data-qa="manager-phones">
            {{ manager.phones[0] }}
          </div>
        </div>
      </div>
    </div>
    <div
      key="footer"
      slot="footer">
      <sButton
        data-qa="btn-startWork"
        @click="modalNewCabinet = false">
        {{ $t('Common.OldCabinet.StartWork') }}
      </sButton>
      <sButton
        data-qa="btn-goToOldCabinet"
        type="text"
        @click="gotoOldCabinet">
        {{ $t('Common.OldCabinet.GoToOldCabinet1') }}
      </sButton>
    </div>
  </sModal>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'
import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

/**
 * Приветственное окно для клиентов переведенных из старого вебклиента
 */
export default {
  name: 'oldCabinetDialog',
  data() {
    return {
      modalNewCabinet: false
    }
  },
  methods: {
    /**
     * Переход в старый кабинет с сохранением статистики
     */
    gotoOldCabinet() {
      api.redirectToOldCabinet('MAIN').then(() => {
        window.open(window.config?.SmarttenderUrl + 'webclient/')
      })
    }
  },
  computed: {
    manager() {
      return this.$store.getters.getPersonalManagerContacts || this.$store.getters.getSupport
    },
  },
  created() {
    this.$nextTick(() => {
      this.modalNewCabinet = true
    })
  },
  components: {
    UserIcon,
  }
}
</script>
